// NoPermissionsMessage.jsx

import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';

const NoPermissionsMessage = ({ module }) => {
  return (
    <Flex justify='center' align='center' h='100%' mt='7rem'>
      <Box p={4} bg='red.100' borderRadius='md'>
        <Text>
          You do not have permissions for {module}. Please contact support.
        </Text>
      </Box>
    </Flex>
  );
};

export default NoPermissionsMessage;
